class Session {
    constructor(id, companyId, intranetId, master, name, email, password, cnpj, serial, roles, config) {
        this.id = id || "";
        this.companyId = companyId || "";
        this.iD_EMPRESA = companyId || "";
        this.intranetId = intranetId || "";
        this.iD_INTRANET = intranetId || "";
        this.master = master || false;
        this.name = name || "";
        this.dS_NAME = name || "";
        this.email = email || "";
        this.password = password || "";
        this.cnpj = cnpj || "";
        this.dS_CNPJ = cnpj || "";
        this.serial = serial || "";
        this.roles = roles || [];
        this.config = config || {};
        this.license = {
            type: "",
            validDays: 0,
            isValid: false,
            elements: []
        };
    }

    // Getters para informações de licença
    getLicenseType() {
        return this.license.type;
    }

    getLicenseValidDays() {
        return this.license.validDays;
    }

    isLicenseValid() {
        return this.license.isValid;
    }

    getLicenseElements() {
        return this.license.elements;
    }

    // Setter para atualizar informações de licença
    setLicenseInfo(type, validDays, isValid, elements) {
        this.license = {
            type,
            validDays,
            isValid,
            elements
        };
    }
}

export default Session;